import { Fab as Chat } from "@material-ui/core"
import React from "react"
import { ThemeContext } from "styled-components";
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';


const WhatsappSupport = () => {
	const handleClick = (e) => {
		const link = 'http://wa.me/5531999917595'
		window.open(link, '_blank');
		e.stopPropagation();
	};

	const HtmlTooltip = withStyles((theme) => ({
		tooltip: {
			fontSize: "14px",
		}
	}))(Tooltip);



	return (
		<ThemeContext.Consumer>
			{theme => (
				<HtmlTooltip placement="top" title="Whatsapp Suporte Técnico" fontSize="20px" arrow>
					<Chat
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							position: 'fixed',
							textAlign: "center",
							bottom: 116,
							right: 15,
							backgroundColor: theme.primary,
							color: "#ffffff",
							fontWeight: "600",
							outline: 'none',
							width: '48px',
							height: '48px'
						}}
						target="_blank"
						variant="extended"
						onClick={(e) => handleClick(e)}
					>
						<i
							className={theme.iconAssistem ? ("") : ("fa fa-brands fa-whatsapp")}
							style={{
								color: '#fff',
								fontSize: '26px',
								margin: '0'
							}}
						/>
					</Chat>
				</HtmlTooltip>
			)}
		</ThemeContext.Consumer>
	)
}

export default WhatsappSupport
